<template>
  <v-app>
  <v-list class="py-0 d-flex flex-column white--text" color="#294A66" height="100vh">
    <div class="d-flex align-center justify-center py-2"  @click="wsbtn('sp_home')">
      <v-avatar
        size="30"
        tile
        class="ml-2"
        style="border:solid white"
      >
        <v-img
          v-if="logoSrc&&logoSrc!=='none'"
          class="preview-item-file"
          :src="logoSrc"
          alt=""
        />
        <v-img
          src="../../assets/logo/logo.png"
          class="preview-item-file"
          alt=""
          v-else
        />
      </v-avatar>
      <h3 class="white--text text-center" style="width:100%;">{{basetitle}}</h3>
    </div>
    <v-divider color="white" class="mx-2 my-1"></v-divider>
    <!-- WSが作られている場合 -->
    <div v-if="wss&&wss.length">
      <!--ホーム-->
      <v-list class="pb-0 pt-0 pl-2" :class="{ selectedBack: routeName=='sp_home' }" @click="today()">
        <router-link to="/sp_home" style="text-decoration:none;">
          <v-list-item class="pb-0 listgroup pl-2">
            <v-list-item-icon class="pt-3">
              <v-img
                src="../../assets/svg/home.svg"
                alt=""
                width="35px"
              ></v-img>
            </v-list-item-icon>
            <v-list-item-content class="ml-2">
              <v-list-item-title :class="{ selectedFont: routeName=='sp_home' }" style="font-size:18px;">
                ホーム
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </router-link>
      </v-list>
      <!-- WS一覧 -->
      <v-list no-action class="ws py-0 ">
        <v-list-group no-action v-model="isWsOpen" class="ws">
          <template v-slot:activator>
            <v-list-item-title class="selectedFont" style="font-size:18px; display: flex; flex-direction: column;">
              <span :style="eachWs&&!isWsOpen ? 'font-size:8px' : ''">ワークスペース</span><span v-if="eachWs&&!isWsOpen" style="margin-left: 8px">{{ eachWs.title }}</span>
            </v-list-item-title>
          </template>
          <div class="noneScBar d-flex flex-column overflow-y-auto overflow-x-hidden">
            <div v-for="ws in wss" :key="ws.sort" @click="wsbtn(ws)" class="py-2 px-3" :class="{ selectedBack: paramsId==ws.id }">
              <router-link :to="'/sp_workspace/'+ ws.id" style="text-decoration:none;">
                <v-icon style="margin-left: 3px; margin-right: 7px;" color="white">mdi-microsoft</v-icon>
                <span class="selectedFont" style="font-size:16px;">{{ ws.title.substr(0, 12) }}</span>
              </router-link>
            </div>
          </div>
        </v-list-group>
      </v-list>
      <!-- WSが選択されている場合 -->
      <div v-if="eachWs">
        <v-divider color="white" class="mx-4 my-2"></v-divider>
        <div class="pa-0" style="max-height: 35vh;">
          <!-- <p class="px-4 my-4 selectedFont" v-if="eachWs&&eachWs.title" style="font-size:18px;">{{ eachWs.title.substr(0, 24) }}</p> -->
          <!--取り組みについて(旧ホーム)-->
          <router-link :to="'/workspace/' + eachWs.id" style="text-decoration:none;">
            <div class="py-2 px-3 d-flex align-center" @click="wsbtn(eachWs)"  :class="{ selectedBack: routeName=='workspace' }">
              <v-icon style="margin-left: 3px; margin-right: 7px;" color="white">mdi-file-document-outline</v-icon>
              <span class="selectedFont" style="font-size:16px;">取り組みについて</span>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <!-- WSが作られていない場合 -->
    <div v-else>
      <!--ホーム-->
      <v-list class="pb-0 pt-0" :class="{ selectedBack: routeName=='sp_home' }" @click="today()">
        <router-link to="/sp_home" style="text-decoration:none;">
          <v-list-item class="pb-0 listgroup">
            <v-list-item-icon class="pt-2">
              <v-img
                src="../../assets/svg/home.svg"
                alt=""
                width="35px"
              ></v-img>
            </v-list-item-icon>
            <v-list-item-content class="ml-6">
              <v-list-item-title :class="{ selectedFont: routeName=='sp_home' }">
                ホーム
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </router-link>
      </v-list>
      <!--lid-->
    </div>
    <!--Lid一覧-->
    <v-list class="pt-0 overflow-y-auto overflow-x-hidden" style="max-height:60vh;">
      <div v-for="item in navlid" :key="item.id">
        <v-list-group v-if="(paramsId === item.id)||item.isfolder||navigationLidType=='dropdown'" no-action class="pt-3" :class="{ navilidr: paramsId === item.id }">
          <template v-slot:activator>
            <v-list-item-content>
              <v-row>
                <v-col cols="3">
                  <v-icon v-if="item.isfolder" style="border:4px solid white">mdi-folder-outline</v-icon>
                  <!-- isOpenがprivateならiconもつけるが、そうでないならiconなし -->
                  <v-badge v-else-if="item.isNotiIdea&&isAuthed"
                    color="deepLava"
                    overlap
                    :icon="item.isOpen=='private'
                      ? (item.isOpenForGovStaff && authConfig.officer)
                        ? 'mdi-office-building-outline'
                        : 'mdi-shield-lock-open-outline'
                      : ''
                    "
                  >
                    <v-btn icon class="lidbtn" style="border:3px solid white; font-size: 8px;" elevation="3" >{{ item.title.substr(0, 2) }}</v-btn>
                  </v-badge>
                  <v-badge v-else-if="item.isOpen=='private'"
                    color="faintHoney"
                    :icon="(item.isOpenForGovStaff && authConfig.officer) ? 'mdi-office-building-outline' : 'mdi-shield-lock-open-outline'"
                    overlap
                  >
                    <v-btn icon class="lidbtn" style="border:3px solid white; font-size: 8px;" elevation="3" >{{ item.title.substr(0, 2) }}</v-btn>
                  </v-badge>
                  <v-btn v-else icon class="lidbtn" style="border:3px solid white; font-size: 8px;" elevation="3" >{{ item.title.substr(0, 2) }}</v-btn>
                </v-col>
                <v-col cols="9" class="d-flex align-center rounded-l-pill" :class="{ thispage: paramsId === item.id }">
                  <v-list-item-title
                    style="width: 150px;white-space:normal;"
                    :style="paramsId === item.id ? 'color: #294A66 !important;font-weight: bold;' : ''"
                  >{{ item.title }}
                  </v-list-item-title>
                </v-col>
              </v-row>
            </v-list-item-content>
          </template>
          <v-row v-if="item.isfolder">
            <v-col cols="2"></v-col><v-col cols="10">
              <v-list-item v-for="childitem in item.childlids" :key="childitem.id" class="pr-0">
                <v-menu right offset-x>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="#008CFF"
                      class="childitembtn"
                      dark
                      width="100%"
                      height="60px"
                      v-bind="attrs"
                      v-on="on"
                    >
                      {{ childitem.title }}
                    </v-btn>
                  </template>

                  <v-list elevation="10" style="background-color: #E0E0E0" @click="today()">
                    <router-link :to="'/lid/' + childitem.id + '/content'" style="text-decoration:none;">
                      <v-list-item class="pr-0">
                        <v-list-item-icon class="pt-2">
                          <v-icon color="#008CFF" width="10px">mdi-information-outline</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content class="pl-2">
                          <v-list-item-title
                            style="color: #294A66"
                            class="rounded-l-pill py-2 pl-2"
                            >{{childitem.zenteiJohoName ? childitem.zenteiJohoName : childitem.zenteiJohoToProjectKaigi ? '会議の内容' : $t('前提情報')}}</v-list-item-title
                          >
                        </v-list-item-content>
                      </v-list-item>
                    </router-link>
                    <router-link :to="'/lid/' + childitem.id + '/idea'" style="text-decoration:none;" v-if="!(hideConfig.idea)&&!(childitem.ideaHidden)">
                      <v-list-item class="pr-0">
                        <v-list-item-icon class="pt-2">
                          <v-img
                            src="../../assets/svg/3012.svg"
                            alt=""
                            width="10px"
                          ></v-img>
                        </v-list-item-icon>
                        <v-list-item-content class="pl-2">
                          <v-list-item-title
                            style="color: #294A66"
                            class="rounded-l-pill py-2 pl-2"
                            >{{$t('アイデア')}}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </router-link>
                    <router-link :to="'/lid/' + childitem.id + '/project'" style="text-decoration:none;"  v-if="!(hideConfig.project)&&!(childitem.projectHidden)">
                      <v-list-item class="pr-0">
                        <v-list-item-icon class="pt-2">
                          <v-img
                            src="../../assets/svg/3013.svg"
                            alt=""
                            width="10px"
                          ></v-img>
                        </v-list-item-icon>
                        <v-list-item-content class="pl-2">
                          <v-list-item-title
                            style="color: #294A66"
                            class="rounded-l-pill py-2 pl-2"
                            >{{childitem.kaizenTeianEnabled ? '改善提案シート' :$t('プロジェクト')}}</v-list-item-title
                          >
                        </v-list-item-content>
                      </v-list-item>
                    </router-link>
                  </v-list>
                </v-menu>
            </v-list-item>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col cols="2"></v-col>
            <v-col cols="10" @click="today()">
              <router-link :to="'/sp/' + item.id + '/content'" style="text-decoration:none;">
                <v-list-item class="pr-0">
                  <v-list-item-icon class="pt-2">
                    <v-icon color="#008CFF" v-if="conttf && paramsId === item.id" width="10px">mdi-information-outline</v-icon>
                    <v-icon color="#008CFF" v-else width="10px">mdi-information-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content class="pl-2">
                    <v-list-item-title
                      :class="{ select: conttf && paramsId === item.id }"
                      style="color: #ffffff"
                      class="rounded-l-pill py-2 pl-2"
                      >{{item.zenteiJohoName ? item.zenteiJohoName : item.zenteiJohoToProjectKaigi ? '会議の内容' : $t('前提情報')}}</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
              </router-link>
              <router-link :to="'/sp/' + item.id + '/idea'" style="text-decoration:none;" v-if="!(hideConfig.idea)&&!(item.ideaHidden)">
                <v-list-item class="pr-0">
                  <v-list-item-icon class="pt-2">
                    <v-img
                      v-if="ideatf && paramsId === item.id"
                      src="../../assets/svg/3012.svg"
                      alt=""
                      width="10px"
                    ></v-img>
                    <v-img
                      v-else
                      src="../../assets/svg/3012.svg"
                      alt=""
                      width="10px"
                    ></v-img>
                  </v-list-item-icon>
                  <v-list-item-content class="pl-2">
                    <v-list-item-title
                      :class="{ select: ideatf && paramsId === item.id }"
                      :style="item.isNotiIdea&&isAuthed ? 'color: #E64550' : 'color: #ffffff'"
                      class="rounded-l-pill py-2 pl-2"
                      >{{$t('アイデア')}}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </router-link>
              <router-link :to="'/sp/' + item.id + '/project'" style="text-decoration:none;" v-if="!(hideConfig.project)&&!(item.projectHidden)">
                <v-list-item class="pr-0">
                  <v-list-item-icon class="pt-2">
                    <v-img
                      v-if="pjtf && paramsId === item.id"
                      src="../../assets/svg/3013.svg"
                      alt=""
                      width="10px"
                    ></v-img>
                    <v-img
                      v-else
                      src="../../assets/svg/3013.svg"
                      alt=""
                      width="10px"
                    ></v-img>
                  </v-list-item-icon>
                  <v-list-item-content class="pl-2">
                    <v-list-item-title
                      :class="{ select: pjtf && paramsId === item.id }"
                      style="color: #ffffff"
                      class="rounded-l-pill py-2 pl-2"
                      >{{item.kaizenTeianEnabled ? '改善提案シート' :$t('プロジェクト')}}</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
              </router-link>
            </v-col>
          </v-row>
        </v-list-group>
        <v-list-item v-else class="pt-3">
            <router-link :to="'/sp/' + item.id + '/idea'" style="color:white;text-decoration:none;">
              <v-row>
                <v-col cols="3">
                  <v-icon v-if="item.isfolder" style="border:4px solid white">mdi-folder-outline</v-icon>
                  <!-- isOpenがprivateならiconもつけるが、そうでないならiconなし -->
                  <v-badge v-else-if="item.isNotiIdea&&isAuthed"
                    color="deepLava"
                    overlap
                    :icon="item.isOpen=='private'
                      ? (item.isOpenForGovStaff && authConfig.officer)
                        ? 'mdi-office-building-outline'
                        : 'mdi-shield-lock-open-outline'
                      : ''
                    "
                  >
                    <v-btn icon class="lidbtn" style="border:3px solid white; font-size: 8px;" elevation="3" >{{ item.title.substr(0, 2) }}</v-btn>
                  </v-badge>
                  <v-badge v-else-if="item.isOpen=='private'"
                    color="faintHoney"
                    :icon="(item.isOpenForGovStaff && authConfig.officer) ? 'mdi-office-building-outline' : 'mdi-shield-lock-open-outline'"
                    overlap
                  >
                    <v-btn icon class="lidbtn" style="border:3px solid white; font-size: 8px;" elevation="3" >{{ item.title.substr(0, 2) }}</v-btn>
                  </v-badge>
                  <v-btn v-else icon class="lidbtn" style="border:3px solid white; font-size: 8px;" elevation="3" >{{ item.title.substr(0, 2) }}</v-btn>
                </v-col>
                <v-col cols="9" class="d-flex align-center rounded-l-pill" :class="{ thispage: paramsId === item.id }">
                  <v-list-item-title
                    style="width: 150px;white-space:normal;"
                    :style="paramsId === item.id ? 'color: #294A66 !important;font-weight: bold;' : ''"
                  >{{ item.title }}
                  </v-list-item-title>
                </v-col>
              </v-row>
            </router-link>
          </v-list-item>
        </div>
    </v-list>
    <!-- 最下部 -->
    <v-list class="mt-auto pb-0" color="#294A66" style="z-index:100;">
      <v-list-item @click="authModal = true" class="mt-auto py-0" v-if="!isAuthed">
        <v-list-item-icon class="mr-4">
          <v-icon color="white">mdi-login-variant</v-icon>
        </v-list-item-icon>
        <v-list-item-content class="py-0">
          <v-list-item-title class=" white--text">ログイン/アカウント作成</v-list-item-title>
        </v-list-item-content>
      </v-list-item> 
      <v-list-item @click="profileModal = true" class="mt-auto py-0" v-else>
        <v-list-item-icon class="mr-3">
          <v-img
            v-if="profImageS"
            class="preview-item-file rounded-circle"
            width="30px"
            height="30px"
            :src="profImageS"
            alt=""
          ></v-img>
          <v-icon v-else color="white">mdi-account</v-icon>
        </v-list-item-icon>
        <v-list-item-content class="py-0">
          <v-list-item-title class=" white--text">{{ currentName }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="isAuthed" @click="signout()">
        <v-list-item-icon class="mr-4">
          <v-icon color="white">mdi-logout-variant</v-icon>
        </v-list-item-icon>
        <v-list-item-content class="py-0">
          <v-list-item-title class=" white--text">ログアウト</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item @click="settings = true">
        <v-list-item-icon class="mr-4">
          <v-icon color="white">mdi-cog</v-icon>
        </v-list-item-icon>
        <v-list-item-content class="py-0">
          <v-list-item-title class=" white--text">設定</v-list-item-title>
        </v-list-item-content>
      </v-list-item> 
      <v-list-item v-if="navi_updateDate" class="py-0 white--text text-center">
        <v-list-item-content class="py-0">
          <p class="mb-0">最終更新：{{ todayy }}</p>
        </v-list-item-content>
      </v-list-item> 
    </v-list>
  </v-list>

    <!--設定画面-->
    <v-dialog fullscreen v-model="settings" height="120%" width="120%">
      <settings :members="members" @closeSetting="closeSettings" :isSp="true"></settings>
    </v-dialog>

    <!--サインイン画面-->
    <v-dialog fullscreen v-if="!isAuthed" v-model="authModal">
      <auth-view
        v-if="authModal"
        defaultView="chooseauth"
        @closeModal="closeAuthModal"
      >
      </auth-view>
    </v-dialog>

    <!--プロフィール画面-->
    <profile_display
      :profile="profileModal"
      :profuid="uid"
      device="sp"
      @closeProfile="closeProfile"
    />
    <!-- 初期・通知確認画面 -->
    <firstUserSetting v-if="askForNotificationModalOpened&&!attributionModalOpened" />
    <!-- アンケート画面 -->
    <attribution v-if="attributionModalOpened" />
    <!-- 重要なお知らせ画面 -->
    <importantAnnounce v-if="importantAnnounceModalOpened" />
  </v-app>
</template>
 
<script>
import firebase from 'firebase'
// import authView from '../../components/auth/authView.vue';
// import profile_display from "../../components/profile/profile_display.vue";
// import settings from '../../components/settings.vue';
// import firstUserSetting from '../../components/firstUserSetting.vue';
const profile_display = () => import('../../components/profile/profile_display.vue')
const authView = () => import('../../components/auth/authView.vue')
const settings = () => import('../../components/settings.vue')
const firstUserSetting = () => import('../../components/firstUserSetting.vue')
const attribution = () => import('../../components/attributionSettingModal.vue')
const importantAnnounce = () => import('../../components/importantAnnounceModal.vue')
export default {
  components:{
    authView,
    profile_display,
    settings,
    firstUserSetting,
    attribution,
    importantAnnounce
  },
  data () {
    return {
      db: null,
      authConfig: JSON.parse(process.env.VUE_APP_AUTH || '{}'),  // 例→ {line:1,slp:0,officer:1}
      hideConfig: JSON.parse(process.env.VUE_APP_HIDE || '{}'),  // 例→ {content:1,idea:0,project:1}
      drawer: false,
      authModal: false,
      profileModal:false,
      settings:false,
      profImageS:"",
      defaultAuthView: "chooseauth",
      todayy: "",
      isAllLid: false,
      isWsOpen: true,
      navigationLidType: process.env.VUE_APP_NAVIGATION_LID_TYPE || 'dropdown',
    }
  },
  watch: {
    eachWs: {
      handler: function (val) {
        if (val) {
          this.isWsOpen = false
        } else {
          this.isWsOpen = true
        }
      },
    },
    paramsId: function(newVal, oldVal) {
      if (this.$route.name === "sp_idea") {
        this.$store.dispatch("getLidMembers", newVal);
      }else if (this.$route.name === "sp_content") {
        this.$store.dispatch("getLidMembers", newVal);
      }else if (this.$route.name === "sp_project") {
        this.$store.dispatch("getLidMembers", newVal);
      }
    },
  },
  computed:{
    paramsId() {
      return this.$route.params.id;
    },
    routeName() {
      return this.$route.name;
    },
    navi_updateDate(){
      if(this.$store.state.config.setting&&this.$store.state.config.setting.navi_updateDate) return this.$store.state.config.setting.navi_updateDate
      else return false
    },
    logoSrc() {
      return this.$store.state.logoSrc;
    },
    members(){
      return this.$store.state.members
    },
    namelist(el){
      return this.$store.state.namelist
    },
    isAdmin(){
      return this.$store.state.isAdmin
    },
    config(){
      return this.$store.state.config
    },
    basetitle(){
      return this.$store.state.basetitle
    },
    wss() {
      return this.$store.getters.wss;
    },
    navlid() {
      const navlid = this.$store.getters.navlid;
      if (this.wss?.length) {
        // WS機能を使用している
        if (this.eachWs) {
          // WSが選択されている場合、そのWSのLidのみを返す
          // return navlid.filter((el)=>this.eachWs.lids.includes(el.id))
          // WSに含まれない、感想Lidなどを表示させるための箇所...
          return navlid.filter((el)=>this.eachWs.lids.includes(el.id)).concat(navlid.filter((el)=>!el.isWs))
        } else {
          if (this.$route.name==="sp_content"||this.$route.name==="sp_idea"||this.$route.name==="sp_project") {
            return navlid.filter((el)=>!el.isWs);
          } else {
            return [];
          }
        }
      } else {
        // WS機能を使用していない
        return navlid;
      }
    },
    lid() {
      return this.$store.state.lid;
    },
    alid() {
      return this.$store.state.alid;
    },
    folderlid() {
      return this.$store.getters.folderlid;
    },
    getSelectColor() {
      return this.inspirecolor(this.postcolor);
    },
    aboutLid() {
      if (this.$store.state.lid.some((u) => u.id === this.$route.params.id)) {
          return this.$store.state.lid.filter((u) => u.id === this.$route.params.id)[0]
        } else if (this.$store.state.alid.some((u) => u.id === this.$route.params.id)) {
          return this.$store.state.alid.filter((u) => u.id === this.$route.params.id)[0]
        } else {
          return null
        }
    },
    uid() {
      return this.$store.state.auth?.user?.uid || '';
    },
    currentName() {
      return this.$store.state.auth.user.displayName;
    },
    isAuthed() {
      return this.$store.state.auth?.isAuthed;
    },
    isGovStaff() {
      return this.$store.state.auth?.user?.isGovStaff || false;
    },
    askForNotificationModalOpened() {
      return this.$store.state.auth.data.askForNotificationModalOpened;
    },
    attributionModalOpened() {
      return this.$store.state.auth.data.attributionModalOpened;
    },
    importantAnnounceModalOpened() {
      return this.$store.state.importantAnnounceModalOpened;
    },
    hometf() {
      if(this.$route.name === "sp_home" || this.$route.name === "sp_workspace"){
        return true;
      }else{
        return false;
      }
    },
    ideatf(){
      if (this.$route.name === "sp_idea") {
        return true;
      }else{
        return false;
      }
    },
    pjtf(){
      if(this.$route.name === "sp_project"){
        return true;
      }else{
        return false;
      }
    },
    conttf(){
      if (this.$route.name === "sp_content") {
        return true;
      }else{
        return false;
      }
    },
    eachWs() {
      let id = ""
      if(this.$route.name==="dashboard"&&this.$route.query.id) id = this.$route.query.id;
      else if(this.$route.name==="sp_workspace"&&this.paramsId) id = this.paramsId;
      else if((this.$route.name==="sp_content"||this.$route.name==="sp_idea"||this.$route.name==="sp_project")&&this.aboutLid&&this.aboutLid.wsId) id = this.aboutLid.wsId;
      if (id) {
        return this.wss.find((el) => el.id === id);
      } else {
        return null
      }
    },
  },
  created(){
    this.db = firebase.firestore()
    this.today()
    this.getProfimg(this.uid)
    if (this.$route.query.account === "choose") {
      this.authModal = true;
    }
    if (this.$route.name === "sp_idea") {
      this.$store.dispatch("getLidMembers", this.paramsId);
    }else if (this.$route.name === "sp_content") {
      this.$store.dispatch("getLidMembers", this.paramsId);
    }else if (this.$route.name === "sp_project") {
      this.$store.dispatch("getLidMembers", this.paramsId);
    }
  },
  methods: {
    wsbtn(ws){
      this.isAllLid=false
      this.$emit('wskey', ws)
    },
    signout() {
      this.$store.dispatch("auth/logout");
    },
    getProfimg(uid){
      //console.log("getpro",uid,this.isAuthed)
      this.db
        .collection("0")
        .doc("config")
        .collection("members")
        .doc(uid)
        .get()
        .then((doc) => {
          //プロフィールの取得
          //this.profImageO = doc.data().profImageO;
          this.profImageS = doc.data().profImageS;
          //console.log("getpro",doc.data())
        });
    },
    closeAuthModal() {
      this.authModal = false
    },
    closeProfile() {
      this.profileModal = false;
    },
    closeSettings(el){
      this.settings = el
    },
    toDoubleDigits(num) {
        num += "";
        if (num.length === 1) {
          num = "0" + num;
        }
      return num; 
    },
    today(){
      // 日付をYYYY/MM/DD HH:DD:MI:SS形式で取得
      let date = new Date();
      let yyyy = date.getFullYear();
      let mm = this.toDoubleDigits(date.getMonth() + 1)
      let dd = this.toDoubleDigits(date.getDate())
      let hh = this.toDoubleDigits(date.getHours())
      let mi = this.toDoubleDigits(date.getMinutes())
      let se = this.toDoubleDigits(date.getSeconds())
      let ms = this.toDoubleDigits(date.getMilliseconds())
      this.todayy = yyyy + "/" + mm + "/" + dd + "  " + hh + ":" + mi + ":" + se
      //console.log("today",this.todayy)
    }  
  }
}
</script>

<style>
i.mdi-office-building-outline{
  font-size: 16px;
  margin-bottom:2px;
}
</style>
<style scoped>
.thispage {
  background-color: #ffffff !important;
  color: #294A66 !important;
  font-weight: bold;
}
.selectedBack{
  background-color: #707070 !important;
}
.selectedFont{
  color: #ffffff !important;
}
.select {
  color: #294A66 !important;
  background-color: white;
}
.listgroup >>> .v-list-item__icon{
  margin: 0px !important;
  width:24px !important;
}
.listgroup .v-list-item__icon{
  margin: 0px !important;
  width:24px !important;
}
.listgroup .v-list-group__header__prepend-icon{
  padding-top: 7% !important;
  padding-right: 1% !important;
  margin-right: 1% !important;
}
.listgroup .v-list-group__header{
  padding-right: 0px !important;
  padding-left: 0px !important;
}
.ws .v-list-group__header{
  height:32px !important;
}
.selectedBack {
  background-color: #707070 !important;
}
.selectedFont {
  color: #ffffff;
}
.lidbtn {
  background-color: #CCE8FF !important;
  color: #2b2b2b !important;
}
.childitembtn{
  justify-content: start;
}
.navilidr >>> .v-list-group__header__append-icon{
  display: none;
  background-color: #ffffff;
  height: 60px !important;
  margin-left: 0px !important;
  padding-right: 16px !important;
}
.navilidr >>> .v-list-item--link{
  padding-right:0px !important;
}
*{
  font-family:mplus-2c-medium !important;
  color: white;
}
</style>

<style>
.v-badge__badge > i.mdi-shield-lock-open-outline {
  /* 非公開Lidを表すアイコン用 */
  font-size: 18px !important;
}
</style>